/* Exartify Gallery theme: header, favourites, product variants, cart, home (hero, palettes, colour swatches, mini try-on), reveals */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const store = {
    get(k, d) { try { const v = localStorage.getItem('exartify:' + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem('exartify:' + k, JSON.stringify(v)); } catch (e) { /* storage unavailable */ } }
  };
  const isStudio = () => !!window.EX_STUDIO;
  function toast(msg) { const t = $('#toast'); if (!t) return; t.textContent = msg; t.classList.add('is-on'); clearTimeout(toast._t); toast._t = setTimeout(() => t.classList.remove('is-on'), 2800); }
  const money = cents => '€' + (cents / 100).toFixed(2).replace(/\.00$/, '');

  /* ---------- header: mobile sheet ---------- */
  const bar = $('#bar'), btn = $('#menu-btn');
  if (bar && btn) {
    const set = open => { bar.dataset.open = open ? 'true' : 'false'; btn.setAttribute('aria-expanded', String(open)); btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); };
    window.__barSet = set; set(false);
    btn.addEventListener('click', e => { e.stopPropagation(); set(bar.dataset.open !== 'true'); });
    document.addEventListener('click', e => { if (!bar.contains(e.target)) set(false); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && bar.dataset.open === 'true') { set(false); btn.focus(); } });
    $('#menu-sheet') && $('#menu-sheet').addEventListener('click', e => { if (e.target.closest('a')) set(false); });
  }

  /* ---------- favourites (the studio page runs its own handler) ---------- */
  const favs = new Set(store.get('favs', []));
  const syncFav = () => { const c = $('#favCount'); if (c) { c.textContent = favs.size; c.dataset.n = favs.size; } $$('[data-fav]').forEach(b => b.setAttribute('aria-pressed', String(favs.has(b.dataset.fav)))); };
  if (!isStudio()) {
    document.addEventListener('click', e => {
      const f = e.target.closest('[data-fav]'); if (!f) return;
      e.preventDefault(); const id = f.dataset.fav;
      favs.has(id) ? favs.delete(id) : favs.add(id); store.set('favs', [...favs]); syncFav();
      toast(favs.has(id) ? `“${f.dataset.favTitle || 'Work'}” saved to favourites` : 'Removed from favourites');
    });
  }
  syncFav();

  /* ---------- cart count ---------- */
  const setCount = n => { const c = $('#cartCount'), l = $('#cartLink'); if (c) { c.textContent = n; c.dataset.n = n; } if (l) l.setAttribute('aria-label', n ? `Cart, ${n} ${n === 1 ? 'item' : 'items'}` : 'Cart'); };

  /* ---------- product page: options → variant, frame preview, AJAX add ---------- */
  const pj = $('#pdJson');
  if (pj) {
    const P = JSON.parse(pj.textContent), form = $('#pdForm'), idIn = $('#pdVariant');
    const groups = $$('.opt', form);
    const selected = () => groups.map(g => { const c = $('input:checked', g); return c ? c.value : null; });
    const findV = vals => P.variants.find(v => v.options.every((o, i) => vals[i] == null || o === vals[i]));
    const printEl = $('#pdPrint'), tag = $('#pdTag');
    const FRAME = [[/дуб|oak/i, 'oak'], [/ч[её]рн|black/i, 'black'], [/бел|white/i, 'white'], [/орех|walnut/i, 'walnut']];
    function look(v) {
      if (!printEl || !v) return;
      const t = v.options.join(' ');
      const mat = /холст|canvas/i.test(t) ? 'canvas' : /без рамы|постер|poster/i.test(t) && !/в раме/i.test(t) ? 'poster' : /рам|frame/i.test(t) ? 'frame' : 'frame';
      printEl.dataset.mat = mat;
      const fr = FRAME.find(([re]) => re.test(t)); if (fr) printEl.dataset.frame = fr[1];
      if (tag) tag.textContent = v.options.filter(o => !/^default/i.test(o)).join(' · ');
    }
    const msg = $('#pdMsg'), MSG0 = msg ? msg.textContent : '';
    const check = opts => groups.forEach((g, i) => { const r = $$('input', g).find(x => x.value === opts[i]); if (r) r.checked = true; });
    function sync(changedIdx) {
      let vals = selected(), v = P.variants.find(x => x.options.every((o, i) => o === vals[i])) || null, note = '';
      if (!v) {
        // the exact combination does not exist: keep what the visitor just picked and say clearly what changed
        const keep = changedIdx == null ? null : vals[changedIdx];
        const score = x => x.options.reduce((a, o, j) => a + (o === vals[j] ? (j < (changedIdx ?? 99) ? 4 : 1) : 0), 0) + (x.available ? .5 : 0);
        const alt = P.variants.filter(x => keep == null || x.options[changedIdx] === keep).sort((a, b) => score(b) - score(a))[0];
        if (alt) {
          v = alt;
          // only mention it when a choice made above the changed one had to move
          if (changedIdx != null && alt.options.some((o, j) => j < changedIdx && o !== vals[j])) note = `That combination does not exist, so we chose: ${alt.title}.`;
        }
      }
      if (v) { check(v.options); vals = v.options.slice(); }
      // mark values that do not exist with the choices above; a group left with a single possible value is collapsed
      groups.forEach((g, i) => {
        let possible = 0;
        $$('input', g).forEach(inp => {
          // a value is offered when it exists together with the choices made above it (earlier option groups)
          const ex = P.variants.find(x => x.options[i] === inp.value && x.options.every((o, j) => j >= i || o === vals[j]));
          const chip = inp.closest('.opt-chip'); chip.classList.toggle('is-off', !ex);
          const sr = chip.querySelector('.sr-note') || chip.appendChild(Object.assign(document.createElement('span'), { className: 'sr sr-note' }));
          sr.textContent = !ex ? ' (combination not available)' : !ex.available ? ' (sold out)' : '';
          if (ex) possible++;
        });
        const hide = possible <= 1 && $$('input', g).length > 1;
        if (hide && g.contains(document.activeElement)) return;
        g.hidden = hide;
      });
      const can = !!(v && v.available && v.price > 0);
      idIn.value = v ? v.id : '';
      $('#pdPrice').textContent = v && v.price > 0 ? money(v.price) : 'Soon';
      ['#pdAdd', '#psAdd'].forEach(sel => { const b = $(sel); if (b) { b.disabled = !can; b.textContent = can ? 'Add to cart' : (v && v.price > 0 ? 'Sold out' : 'Coming soon'); } });
      const pm = $('#psMeta'), pp = $('#psPrice'); if (pm) pm.textContent = v ? v.title : ''; if (pp) pp.textContent = v && v.price > 0 ? money(v.price) : '';
      if (msg) msg.textContent = note || MSG0;
      look(v);
      if (v && changedIdx != null && history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    }
    groups.forEach((g, i) => g.addEventListener('change', () => sync(i)));
    sync(null);

    // views: wall render or a product photo
    const alt = $('#pdAlt');
    $$('[data-pv]').forEach(b => b.addEventListener('click', () => {
      $$('[data-pv]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      if (b.dataset.pv === 'wall') { alt.hidden = true; alt.innerHTML = ''; printEl.hidden = false; }
      else { const im = document.createElement('img'); im.src = b.dataset.pv; im.alt = b.dataset.alt || ''; alt.replaceChildren(im); alt.hidden = false; printEl.hidden = true; }
    }));

    form.addEventListener('submit', e => {
      e.preventDefault();
      const add = $('#pdAdd'); if (add.disabled || !idIn.value) return; add.disabled = true; const sticky = $('#psAdd'); if (sticky) sticky.disabled = true;
      fetch(window.EX.routes.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +idIn.value, quantity: 1 }] }) })
        .then(r => r.json().then(j => ({ ok: r.ok, j })))
        .then(({ ok, j }) => {
          if (!ok) throw new Error(j.description || j.message || 'Could not add to cart');
          return fetch(window.EX.routes.cart + '.js').then(r => r.json()).then(c => { setCount(c.item_count); toast(`“${P.title}” added to cart`); });
        })
        .catch(err => { toast(err.message); if (msg) msg.textContent = err.message; })
        .finally(() => { add.disabled = false; if (sticky) sticky.disabled = false; });
    });

    // sticky buy bar once the main button scrolls away
    const st = $('#pdSticky'), buy = $('.pd-buy');
    if (st && buy && 'IntersectionObserver' in window) new IntersectionObserver(([en]) => { const on = !en.isIntersecting && en.boundingClientRect.top < 0; st.classList.toggle('is-on', on); st.setAttribute('aria-hidden', String(!on)); st.inert = !on; }).observe(buy);
  }

  /* ---------- product recommendations ---------- */
  const recs = $('[data-recs]');
  if (recs && !recs.children.length && recs.dataset.url) {
    fetch(recs.dataset.url).then(r => r.text()).then(t => { const d = document.createElement('div'); d.innerHTML = t; const s = d.querySelector('[data-recs]'); if (s && s.children.length) { recs.innerHTML = s.innerHTML; syncFav(); paintLabels(recs); } }).catch(() => {});
  }

  /* ---------- cart page: quantity steppers ---------- */
  const cf = $('#cartForm');
  if (cf) {
    const change = (key, qty) => fetch(window.EX.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(r => { if (!r.ok) return r.json().then(j => { throw new Error(j.description || j.message || 'Could not change the quantity'); }); location.reload(); })
      .catch(err => toast(err.message));
    cf.addEventListener('click', e => {
      const b = e.target.closest('[data-qty-step]'); if (!b) return;
      const inp = $(`.ci-num[data-key="${CSS.escape(b.dataset.key)}"]`); const q = Math.max(0, Math.min(99, (+inp.value || 0) + +b.dataset.qtyStep));
      inp.value = q; b.disabled = true; change(b.dataset.key, q);
    });
    cf.addEventListener('change', e => { if (e.target.matches('.ci-num')) change(e.target.dataset.key, Math.max(0, Math.min(99, +e.target.value || 0))); });
  }

  /* ---------- home: pick a shade → nearest work by palette ---------- */
  const sw = $('[data-swatches]');
  if (sw) {
    const cap = $('[data-swatch-cap]'), go = $('[data-swatch-go]');
    const lab = (r, g, b) => { const f = v => { v /= 255; return v <= .04045 ? v / 12.92 : Math.pow((v + .055) / 1.055, 2.4); }; const R = f(r), G = f(g), B = f(b); let x = (R * .4124 + G * .3576 + B * .1805) / .95047, y = R * .2126 + G * .7152 + B * .0722, z = (R * .0193 + G * .1192 + B * .9505) / 1.08883; const k = t => t > .008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; x = k(x); y = k(y); z = k(z); return [116 * y - 16, 500 * (x - y), 200 * (y - z)]; };
    const hexLab = h => { const n = parseInt(h.slice(1), 16); return lab(n >> 16 & 255, n >> 8 & 255, n & 255); };
    const dE = (a, b) => Math.hypot(a[0] - b[0], a[1] - b[1], a[2] - b[2]);
    let works = null;
    const samples = src => new Promise(res => {
      const img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = () => { try { const c = document.createElement('canvas'); c.width = 24; c.height = 24; const x = c.getContext('2d'); x.drawImage(img, 0, 0, 24, 24); const d = x.getImageData(0, 0, 24, 24).data, out = []; for (let i = 0; i < d.length; i += 4) out.push(lab(d[i], d[i + 1], d[i + 2])); res(out); } catch (e) { res(null); } };
      img.onerror = () => res(null); img.src = src;
    });
    const load = () => works || (works = fetch((window.EX.routes.catalog || '/collections/all') + '/products.json?limit=60').then(r => r.json()).then(j => j.products || []).catch(() => []).then(ps => {
      const list = ps.filter(p => p.images && p.images[0]).map(p => ({ t: p.title, url: '/products/' + p.handle, src: p.images[0].src + (p.images[0].src.includes('?') ? '&' : '?') + 'width=200' }));
      return Promise.all(list.map(w => samples(w.src).then(px => Object.assign(w, { px })))).then(l => l.filter(w => w.px));
    }));
    sw.addEventListener('click', e => {
      const b = e.target.closest('.g-swatch'); if (!b) return;
      $$('.g-swatch', sw).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      cap.textContent = `${b.dataset.name}: finding the closest work…`;
      const L = hexLab(b.dataset.hex);
      go.href = go.href.split('#')[0] + '#/match/color';
      try { localStorage.setItem('exartify:pick', JSON.stringify({ hex: b.dataset.hex.toUpperCase(), name: b.dataset.name })); } catch (er) { /* ignore */ }
      load().then(ws => {
        if (!ws.length) { cap.textContent = `${b.dataset.name}: open the match page to see works in this shade.`; return; }
        const best = ws.map(w => ({ w, s: w.px.reduce((a, p) => a + Math.exp(-dE(p, L) / 18), 0) })).sort((a, c) => c.s - a.s)[0].w;
        cap.innerHTML = `${esc(b.dataset.name)}: the closest is “<a href="${best.url}">${esc(best.t)}</a>”.`;
      });
    });
  }

  /* ================= home: palettes, hero, mini try-on, reveals ================= */
  const reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hex2rgb = x => { const n = parseInt(x.slice(1), 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; };
  const rgb2hex = (r, g, b) => '#' + [r, g, b].map(v => Math.round(v).toString(16).padStart(2, '0')).join('').toUpperCase();
  const toLab = (r, g, b) => { const f = v => { v /= 255; return v <= .04045 ? v / 12.92 : Math.pow((v + .055) / 1.055, 2.4); }; const R = f(r), G = f(g), B = f(b); let x = (R * .4124 + G * .3576 + B * .1805) / .95047, y = R * .2126 + G * .7152 + B * .0722, z = (R * .0193 + G * .1192 + B * .9505) / 1.08883; const k = t => t > .008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; x = k(x); y = k(y); z = k(z); return [116 * y - 16, 500 * (x - y), 200 * (y - z)]; };
  const dist = (a, b) => Math.hypot(a[0] - b[0], a[1] - b[1], a[2] - b[2]);
  const relLum = x => { const [r, g, b] = hex2rgb(x).map(v => { v /= 255; return v <= .03928 ? v / 12.92 : ((v + .055) / 1.055) ** 2.4; }); return .2126 * r + .7152 * g + .0722 * b; };
  /* six-colour k-means palette of an image (same method as the studio), cached per URL */
  const palCache = {};
  function paletteOf(src, k = 6) {
    if (!src) return Promise.resolve(null);
    if (palCache[src]) return palCache[src];
    return (palCache[src] = new Promise(res => {
      const img = new Image(); img.crossOrigin = 'anonymous'; img.decoding = 'async';
      img.onload = () => {
        try {
          const W = 40, H = Math.max(8, Math.round(40 * img.naturalHeight / img.naturalWidth));
          const cv = document.createElement('canvas'); cv.width = W; cv.height = H;
          const cx = cv.getContext('2d', { willReadFrequently: true }); cx.drawImage(img, 0, 0, W, H);
          const d = cx.getImageData(0, 0, W, H).data, pts = [];
          for (let i = 0; i < d.length; i += 4) pts.push({ rgb: [d[i], d[i + 1], d[i + 2]], lab: toLab(d[i], d[i + 1], d[i + 2]) });
          const mean = [0, 0, 0]; pts.forEach(p => { mean[0] += p.lab[0]; mean[1] += p.lab[1]; mean[2] += p.lab[2]; }); mean.forEach((v, i) => { mean[i] = v / pts.length; });
          let best = 0, bd = 1e9; pts.forEach((p, i) => { const q = dist(p.lab, mean); if (q < bd) { bd = q; best = i; } });
          const cents = [pts[best].lab.slice()];
          while (cents.length < k) { let far = 0, fd = -1; pts.forEach((p, i) => { const q = Math.min(...cents.map(c => dist(c, p.lab))); if (q > fd) { fd = q; far = i; } }); cents.push(pts[far].lab.slice()); }
          const asg = new Int32Array(pts.length);
          for (let it = 0; it < 10; it++) {
            pts.forEach((p, i) => { let bi = 0, bv = 1e9; cents.forEach((c, j) => { const q = dist(c, p.lab); if (q < bv) { bv = q; bi = j; } }); asg[i] = bi; });
            const sum = cents.map(() => [0, 0, 0, 0]);
            pts.forEach((p, i) => { const t = sum[asg[i]]; t[0] += p.lab[0]; t[1] += p.lab[1]; t[2] += p.lab[2]; t[3]++; });
            sum.forEach((t, j) => { if (t[3]) cents[j] = [t[0] / t[3], t[1] / t[3], t[2] / t[3]]; });
          }
          const acc = cents.map(() => [0, 0, 0, 0]);
          pts.forEach((p, i) => { const a = acc[asg[i]]; a[0] += p.rgb[0]; a[1] += p.rgb[1]; a[2] += p.rgb[2]; a[3]++; });
          res(acc.filter(a => a[3]).map(a => { const rgb = [a[0] / a[3], a[1] / a[3], a[2] / a[3]]; return { hex: rgb2hex(...rgb), w: a[3] / pts.length, chroma: (Math.max(...rgb) - Math.min(...rgb)) / 255 }; }).sort((a, b) => b.w - a.w));
        } catch (e) { res(null); }
      };
      img.onerror = () => res(null);
      img.src = src;
    }));
  }
  const accent = pal => { const p = pal.filter(c => c.w > .05).sort((a, b) => b.chroma * Math.sqrt(b.w) - a.chroma * Math.sqrt(a.w))[0]; return (p || pal[0]).hex; };
  const dots = (box, pal, n = 5) => { if (box) box.innerHTML = pal.slice(0, n).map(p => `<i style="background:${p.hex}"></i>`).join(''); };

  /* cards and collection tiles: tinted wall + museum-label palette dots */
  function paintLabels(root = document) {
    const els = $$('[data-pal-src]:not([data-pal-done])', root).filter(el => !el.classList.contains('v-slide'));
    const run = el => { el.dataset.palDone = '1'; paletteOf(el.dataset.palSrc).then(pal => {
      if (!pal) return;
      const tint = accent(pal), wall = $('.wall', el);
      (wall || el).style.setProperty('--tint', tint);
      dots($('[data-pal]', el), pal);
    }); };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { io.unobserve(en.target); run(en.target); } }), { rootMargin: '300px 0px' });
    els.forEach(el => io.observe(el));
  }
  if (!isStudio()) paintLabels();
  window.EXpaintLabels = paintLabels;

  /* human colour names for the palette strip (nearest of a small named set, in Lab) */
  const NAMED = [['#F4EFE6','Milk'],['#E8DCC8','Linen'],['#D9C2A0','Sand'],['#C9A26B','Ochre'],['#B8863B','Honey'],['#8C6A3F','Walnut'],['#5A4632','Umber'],['#F2C7B8','Peach'],['#E9B4B8','Blush'],['#D98E8E','Rose'],['#C25B4E','Terracotta'],['#9E2F2A','Brick'],['#6E2430','Burgundy'],['#C8B6D6','Lilac'],['#8E7AA8','Heather'],['#B9D3E6','Sky'],['#7FA2C2','Powder blue'],['#3F5F82','Lake'],['#22344D','Ink blue'],['#121A26','Night'],['#A9B79A','Sage'],['#6F7F5A','Olive'],['#3E4C36','Moss'],['#D7DCD9','Mist'],['#A3A8AA','Pewter'],['#6B6F73','Slate'],['#3A3D41','Graphite'],['#1A1B1D','Soot'],['#E8C66A','Gold'],['#F7E9C4','Cream'],['#B9B4C7','Lavender grey'],['#C99AA3','Dusty rose'],['#F0D9D3','Shell'],['#F3C1A5','Apricot'],['#8A8F7A','Lichen'],['#2E3A46','Deep slate']];
  const NAMED_LAB = NAMED.map(([h, n]) => [toLab(...hex2rgb(h)), n]);
  const colourName = hex => { const L = toLab(...hex2rgb(hex)); let best = NAMED_LAB[0], bd = 1e9; NAMED_LAB.forEach(x => { const d = dist(x[0], L); if (d < bd) { bd = d; best = x; } }); return best[1]; };

  /* hero: living stills (or a looping video), caption and palette strip follow the slide */
  const hero = $('[data-hero]');
  if (hero) {
    const slides = $$('.v-slide', hero), video = $('#vVideo', hero), pause = $('#vPause', hero), palEl = $('#vPal');
    const nowT = $('#vNowT'), nowC = $('#vNowC'), now = $('#vNow');
    const every = (+hero.dataset.interval || 8) * 1000;
    let cur = Math.max(0, slides.findIndex(s => s.classList.contains('is-on'))), timer = 0, userPaused = reduceMotion, visible = true;
    const paintPal = sl => {
      if (!palEl) return;
      paletteOf(sl.dataset.palSrc).then(pal => {
        if (!pal || slides[cur] !== sl) return;
        const cols = pal.slice(0, 5).map(p => p.hex).sort((a, b) => relLum(a) - relLum(b)); const seen = {}; const names = cols.map(c => { let n = colourName(c); if (seen[n]) n = (relLum(c) > seen[n] ? 'Pale ' : 'Deep ') + n.toLowerCase(); else seen[n] = relLum(c); return n; });
        if (!palEl.children.length) cols.forEach(() => { const li = document.createElement('li'); li.appendChild(document.createElement('span')); palEl.appendChild(li); });
        palEl.setAttribute('aria-label', `Palette of “${sl.dataset.t || ''}”`);
        $$('li', palEl).forEach((li, k) => { const c = cols[k] || cols[cols.length - 1]; li.style.background = c; li.classList.toggle('on-dark', relLum(c) < .179); li.firstChild.textContent = names[k] || colourName(c); li.title = c; });
        palEl.hidden = false;
      });
    };
    const nowP = $('#vNowP'); const caption = i => { const sl = slides[i]; if (!sl) return; if (nowT) nowT.textContent = sl.dataset.t || ''; if (nowC) nowC.textContent = sl.dataset.c || ''; if (nowP) nowP.textContent = sl.dataset.p || ''; if (now && sl.dataset.u) now.href = sl.dataset.u; paintPal(sl); };
    const show = i => { if (slides.length < 2) return; slides[cur].classList.remove('is-on'); cur = (i + slides.length) % slides.length; const sl = slides[cur]; if (sl.loading === 'lazy') sl.loading = 'eager'; sl.classList.add('is-on'); caption(cur); };
    const running = () => !userPaused && visible;
    const tick = () => { clearTimeout(timer); if (running() && !video && slides.length > 1) timer = setTimeout(() => { show(cur + 1); tick(); }, every); };
    const sync = () => {
      hero.classList.toggle('is-paused', !running());
      if (pause) { pause.setAttribute('aria-pressed', String(userPaused)); pause.setAttribute('aria-label', userPaused ? 'Play background' : 'Pause background'); }
      if (video) { if (running()) { const pr = video.play(); if (pr) pr.catch(() => {}); } else video.pause(); }
      tick();
    };
    if (video) slides.forEach(s => s.classList.add('is-poster'));
    if (pause) pause.addEventListener('click', () => { userPaused = !userPaused; sync(); });
    if (pause && slides.length < 2 && !video) pause.hidden = true;
    // warm the next stills once the page is idle, so cross-fades never show a blank frame
    setTimeout(() => slides.forEach(s => { if (s.loading === 'lazy') s.loading = 'eager'; }), 2500);
    if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => { visible = en.isIntersecting; sync(); }, { threshold: .15 }).observe(hero);
    caption(cur); sync();
  }

  const mt = $('[data-minitry]');
  if (mt) {
    const scene = $('#mtScene', mt), works = $$('[data-k="work"]', mt), sizeBox = $('#mtSize', mt);
    const rooms = {"living-milk":{"s":3.3772727272727274,"cx":764,"base":562,"gap":22,"light":true},"living-graphite":{"s":3.7409090909090907,"cx":775,"base":522,"gap":22,"light":false},"bedroom-powder":{"s":3.10625,"cx":769.5,"base":490,"gap":22,"light":true},"bedroom-sage":{"s":3.20625,"cx":770.5,"base":503,"gap":22,"light":true},"office-blue":{"s":4.45,"cx":766.5,"base":571,"gap":15,"light":true},"dining-terra":{"s":4.288888888888889,"cx":773,"base":550,"gap":22,"light":true},"hall-beige":{"s":4.866666666666666,"cx":738,"base":623,"gap":15,"light":true},"living-walnut":{"s":4.35,"cx":768,"base":574,"gap":15,"light":true}};
    const parse = b => ({ sizes: (b.dataset.sizes || '').split(',').filter(Boolean).map(x => x.split('x').map(Number)), prices: (b.dataset.prices || '').split(',').filter(Boolean).map(Number), vids: (b.dataset.vids || '').split(',').filter(Boolean) });
    const st = { room: $('[data-k="room"][aria-pressed="true"]', mt) || $('[data-k="room"]', mt), work: works[0], tier: 1 };
    const bg = $('#mtRoomImg', mt), art = $('#mtArt', mt), status = $('#mtRoomStatus', mt);
    let photoReady = bg.complete && bg.naturalWidth > 0, photoFailed = false;
    const showStatus = (text, hideArt) => { status.textContent = text; status.hidden = !text; art.hidden = hideArt; };
    const buildSizes = () => {
      const { sizes } = parse(st.work);
      sizeBox.innerHTML = sizes.map(([a, b], i) => `<button class="mt-opt mt-size" type="button" data-k="tier" data-v="${i}" aria-pressed="false" aria-label="${a} by ${b} cm">${a}×${b}</button>`).join('');
      st.tier = Math.min(st.tier, Math.max(0, sizes.length - 1));
    };
    const paint = () => {
      if (!st.work || !st.room) { mt.hidden = true; return; }
      const w = st.work, { sizes, prices, vids } = parse(w), sz = sizes[st.tier]; if (!sz) return;
      const [cw, ch] = sz, R = rooms[st.room.dataset.v]; if (!R) return;
      const src = st.room.dataset.src;
      if (bg.getAttribute('src') !== src) { photoReady = false; photoFailed = false; bg.src = src; }
      scene.style.setProperty('--cm', `calc(100cqw / ${1536 / R.s})`);
      scene.style.setProperty('--aw', cw); scene.style.setProperty('--ah', ch);
      scene.classList.toggle('is-dark', !R.light);
      art.style.left = `${R.cx / 1536 * 100}%`;
      const paperHeight = ch * R.s;
      const fitsAbove = paperHeight + 48 + 12 * R.s <= R.base;
      const maxTop = Math.max(48, (fitsAbove ? R.base : 1024) - paperHeight - 12 * R.s);
      const top = Math.max(48, Math.min(maxTop, R.base - (R.gap + ch) * R.s));
      art.style.top = `${top / 1024 * 100}%`;
      art.dataset.printWidthCm = cw; art.dataset.printHeightCm = ch;
      art.dataset.pxPerCm = R.s;
      scene.classList.toggle('has-fit-note', top + paperHeight > R.base);
      const img = $('#mtImg', mt); if (img.getAttribute('src') !== w.dataset.src) img.src = w.dataset.src;
      $('#mtDim', mt).textContent = `${cw} × ${ch} cm`;
      scene.setAttribute('aria-label', `${w.dataset.title}, ${cw} × ${ch} cm, ${st.room.dataset.name}`);
      if (photoFailed) showStatus(mt.dataset.error, true);
      else if (!photoReady) showStatus(mt.dataset.loading, true);
      else if (top + paperHeight > R.base) showStatus(mt.dataset.fit, false);
      else showStatus('', false);
      const price = $('#mtPrice', mt);
      if (price) price.innerHTML = `<b>${esc(w.dataset.title)}</b><span>${cw} × ${ch} cm · ${prices[st.tier] ? money(prices[st.tier]) : ''}</span>`;
      const productLink = $('#mtProduct', mt);
      if (productLink) productLink.href = w.dataset.url + (vids[st.tier] ? '?variant=' + vids[st.tier] : '');
      const go = $('#gTryGo', mt);
      if (go) { const url = new URL(go.href, location.href); url.searchParams.set('room', st.room.dataset.v); url.searchParams.set('tier', st.tier); url.hash = '/tryon/' + encodeURIComponent(w.dataset.v); go.href = url.href; }
      $$('.mt-opt', mt).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.k === 'tier' ? +b.dataset.v === st.tier : b === st[b.dataset.k])));
    };
    bg.addEventListener('load', () => { photoReady = true; photoFailed = false; paint(); });
    bg.addEventListener('error', () => { photoReady = false; photoFailed = true; paint(); });
    $('.mt-ctl', mt).addEventListener('click', e => {
      const b = e.target.closest('.mt-opt'); if (!b) return;
      if (b.dataset.k === 'tier') st.tier = +b.dataset.v;
      else { st[b.dataset.k] = b; if (b.dataset.k === 'work') buildSizes(); }
      paint();
    });
    // Compact mobile panels keep the preview and the purchase actions on screen.
    const tabs = $$('[data-mt-tab]', mt), panels = $$('[data-mt-panel]', mt);
    const mobile = matchMedia('(max-width: 760px)');
    let activePanel = 'room';
    const syncPanels = () => {
      tabs.forEach(tab => {
        const active = tab.dataset.mtTab === activePanel;
        tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(panel => {
        const key = panel.dataset.mtPanel;
        panel.hidden = mobile.matches && key !== activePanel;
        if (mobile.matches) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', 'mtTab' + key[0].toUpperCase() + key.slice(1));
        } else { panel.removeAttribute('role'); panel.removeAttribute('aria-labelledby'); }
      });
    };
    tabs.forEach(tab => {
      tab.addEventListener('click', () => { activePanel = tab.dataset.mtTab; syncPanels(); });
      tab.addEventListener('keydown', e => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault();
        let i = tabs.indexOf(tab);
        i = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        activePanel = tabs[i].dataset.mtTab; syncPanels(); tabs[i].focus();
      });
    });
    mobile.addEventListener('change', syncPanels);
    $$('.mt-opts, .mt-room-opts', mt).forEach(group => group.addEventListener('keydown', e => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
      const opts = $$('.mt-opt', group), current = opts.indexOf(e.target);
      if (current < 0) return;
      e.preventDefault();
      const i = e.key === 'Home' ? 0 : e.key === 'End' ? opts.length - 1 : (current + (e.key === 'ArrowRight' ? 1 : -1) + opts.length) % opts.length;
      opts[i].focus(); opts[i].click();
    }));
    syncPanels();
    if (st.work) buildSizes();
    paint();
  }

  /* footer: a strip made from every work's palette */
  const ft = $('#ftPal');
  if (ft && ft.dataset.ftSrc) {
    const srcs = ft.dataset.ftSrc.split('|').filter(Boolean);
    const fill = () => Promise.all(srcs.map(s => paletteOf(s))).then(ps => {
      ps.forEach(pal => { if (!pal) return; pal.slice(0, 3).forEach(p => { const li = document.createElement('li'); li.style.background = p.hex; ft.appendChild(li); }); });
    });
    if ('IntersectionObserver' in window) { const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); fill(); } }, { rootMargin: '400px 0px' }); io.observe(ft); } else fill();
  }

  /* reveals (the studio page runs its own) */
  if (!isStudio()) {
    const els = $$('.rv, .rv-kids');
    if (reduceMotion || !('IntersectionObserver' in window)) els.forEach(e => e.classList.add('in'));
    else {
      const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
      els.forEach(e => io.observe(e));
      setTimeout(() => els.forEach(e => { if (e.getBoundingClientRect().top < innerHeight) e.classList.add('in'); }), 60);
    }
  }
})();


